import { useQuery } from '@tanstack/react-query';
import { UseQueryOptions } from '@type/index';
import { safeString } from '@utils/stringUtil';
import { getTableById } from '..';

function useTableDetail(id?: string, options?: UseQueryOptions<typeof getTableById>) {
  return useQuery({
    queryKey: ['table-detail', id],
    queryFn: () => getTableById(safeString(id)),
    enabled: !!id,
    ...options,
  });
}

export default useTableDetail;
